import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Accordion } from 'cd-eft/components/common/Accordion';
import { Input } from 'cd-eft/components/common/Input/Input';
import { Row, Col, Modal, ModalBody, ModalHeader, ModalFooter, Container } from 'reactstrap';
import { liningMaterialOptions, WaterwayInputVM } from './WaterwayInputVM';
import { WaterwayCommentsComp } from './WaterwayComments/WaterwayComments';
import { UserLeavingWarning } from 'cd-eft/components/common/UserLeavingWarning/UserLeavingWarning';
import { ComboBox } from 'cd-eft/components/common/ComboBox';
import { WaterWayInputDetails } from './IDetails';
import Icon from '@mdi/react';
import { RadioGroup } from 'cd-eft/components/common/RadioGroup';
import { mdiOpenInNew, mdiRestore, mdiPlusThick, mdiMinusThick } from '@mdi/js';
import './WaterwayInput.scss'
import stores from 'cd-eft/models/Stores';
import { Popup } from 'cd-eft/components/common/Popup';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
const { designStore, waterwayDesignStore } = stores.AppStore;

interface ISubFormProps {
  vm: WaterwayInputVM;
}

interface WDTWInputProps {
  toggleAddWaterwayClicked?: any;
  // triggerReloadInputs:boolean;
  retriveFlowCalculationResults: any;
  getAllReachesByAlignedElementDesignParametersId: any;
  getNotificationStatus: any;
  getDesignUiState: any;
  getWDTContainerDataOnMount: any;
}


const InfoForm = observer((props: ISubFormProps) => {
  const vm = props.vm;

  return (
    <div className="wdt-info-container col">

      <Input
        idAndName='waterway_name'
        label='Waterway Name'
        valid={!props.vm.infoFormValidation.waterway_name}
        value={waterwayDesignStore.waterwayName || props.vm.waterwayName}
        type='text'
        onChange={props.vm.handleInfoFormChange}
        wrapperClassName='waterwayHorizontal'
        className={props.vm.infoFormValidation.formErrors.waterway_name}
        onBlur={props.vm.validateInputField}
        required={true}
      />

      {(waterwayDesignStore.waterwayType === 'Lined Waterway' || waterwayDesignStore.currentWaterwayDesignElementTypeId === 19) && (
        <>

          <ComboBox
            idAndName="liningMaterial"
            label="Lining Material"
            aria-label="Select Lining Material"
            valid={true}
            value={props.vm.liningMaterailForm.selectedLiningMaterail}
            onChange={props.vm.openLiningMaterialChangeConfirmation}
            onBlur={(e) => props.vm.validateLinedMaterialInput(e.target.name, e.target.value)}
            options={props.vm.liningMaterialOptions}
            errorMsg={''}
            required={true}
            className={props.vm.liningMaterialFormValidation.formErrors.liningMaterialOption}
          />
          {!vm.liningMaterailForm.disabledManual &&
            <Input
              idAndName='LiningMaterialName'
              label='Lining Material Name'
              valid={true}
              value={props.vm.liningMaterailForm.manualEntryLiningMaterailName}
              type='string'
              onChange={props.vm.handleLiningMaterialOnChange}
              onBlur={(e) => props.vm.validateLinedMaterialInput(e.target.name, e.target.value)}
              wrapperClassName='waterwayHorizontal'
              className={vm.liningMaterailForm.disabledManual ? 'no-border' : props.vm.liningMaterialFormValidation.formErrors.manualEntryMaterialName}
            />
          }

          <Input
            idAndName='manning'
            label='Manning&#39;s n'
            valid={true}
            value={props.vm.liningMaterailForm.manning.toString()}
            type='number'
            onChange={props.vm.handleLiningMaterialOnChange}
            onBlur={(e) => props.vm.validateLinedMaterialInput(e.target.name, e.target.value)}
            wrapperClassName='waterwayHorizontal'
            readOnly={props.vm.liningMaterailForm.disabledManual}
            className={vm.liningMaterailForm.disabledManual ? 'no-border' : props.vm.liningMaterialFormValidation.formErrors.manualEntryManning}
          />
          <Input
            idAndName='thickness'
            label='Lining Thickness (in)'
            valid={true}
            value={props.vm.liningMaterailForm.thickness}
            type='number'
            onChange={props.vm.handleLiningMaterialOnChange}
            onBlur={(e) => props.vm.validateLinedMaterialInput(e.target.name, e.target.value)}
            wrapperClassName='waterwayHorizontal'
            readOnly={props.vm.liningMaterailForm.disabledManual}
            className={vm.liningMaterailForm.disabledManual ? 'no-border' : props.vm.liningMaterialFormValidation.formErrors.manualEntryThickness}
          />
        </>
      )}

      <span><strong>Waterway Benchmark (optional)</strong></span>

      <Input idAndName='construction_benchmark'
        label='Benchmark ID'
        valid={true}
        value={props.vm.constructionBenchmark}
        type='text'
        onChange={props.vm.handleInfoFormChange}
        onBlur={props.vm.validateInputField}
        wrapperClassName='waterwayHorizontal'
      />


      <Input idAndName='construction_elevation'
        label='Benchmark Elevation (ft)'
        valid={true}
        value={props.vm.constructionElevation}
        type='number'
        onChange={props.vm.handleInfoFormChange}
        onBlur={props.vm.validateInputField}
        step={'0.01'}
        wrapperClassName='waterwayHorizontal'
      />


      <Input idAndName='benchmark_description'
        label='Benchmark Description'
        valid={true}
        value={props.vm.benchmarkDescription}
        type='text'
        onChange={props.vm.handleInfoFormChange}
        onBlur={props.vm.validateInputField}
      />

      <Input idAndName='spoil_disposal'
        label='Spoil Disposal'
        valid={true}
        value={props.vm.spoilDisposal}
        type='text'
        onChange={props.vm.handleInfoFormChange}
        onBlur={props.vm.validateInputField}
      />
    </div >
  );
})

const AlignmentForm = observer((props: ISubFormProps) => {
  return (
    <div className="wdt-alignment-container col">
      <ComboBox
        idAndName="alignment"
        label="Alignment"
        aria-label="Alignment"
        valid={!props.vm.alignmentFormValidation.alignment}
        value={props.vm.selectedAlignmentId}
        onChange={props.vm.handleAlignmentFormChange}
        onBlur={props.vm.validateInputField}
        options={props.vm.alignmentOptions}
        errorMsg={''}
        required={true}
        className={props.vm.alignmentFormValidation.formErrors.alignment}
      />
      <Input
        idAndName='seeding_buffer_width'
        label='Seeding Buffer Width (ft) (optional)'
        valid={true}
        value={props.vm.seedingBufferWidth}
        type='number'
        onBlur={props.vm.validateInputField}
        onChange={props.vm.handleAlignmentFormChange}
        step={'0.01'}
        wrapperClassName='waterwayHorizontal'
        className={props.vm.alignmentFormValidation.formErrors.seedingBufferWidth}
      />
      <div className='controls-radio-group channel-control-group'>
        <RadioGroup
          labelId="alignment-buffer-Options"
          items={[
            {
              id: 'alignment-Channel-Border',
              name: 'alignment-Channel-Border',
              label: 'Channel Border',
              className: 'control-radio-button usa-radio__input--tile',
              onChange: props.vm.selectSeedingBufferOption,
              checked: props.vm.alignmentChannelBorder,
            },
            {
              id: 'alignment-water-level',
              name: 'alignment-water-level',
              label: 'Water Level',
              className: 'control-radio-button usa-radio__input--tile',
              onChange: props.vm.selectSeedingBufferOption,
              checked: props.vm.alignmentWaterLevel,
              disabled: waterwayDesignStore.waterwayType === 'Lined Waterway' || waterwayDesignStore.currentWaterwayDesignElementTypeId === 19,
            },
          ]}
        />
      </div>
    </div>
  )
})

const HydrologyForm = observer((props: ISubFormProps) => {
  return (
    <div className="wdt-hydrology-container col">
      <div><strong>Storm Runoff</strong></div>
      <Row>
        <Col className='wdt-hydrology-project-combobox-col'>
          {props.vm.HydroByAlignmentAoiData ?
            <ComboBox
              idAndName="hydrology_project"
              label="Hydrology Project"
              aria-label="HydrologyProject"
              valid={!props.vm.hydrologyFormValidation.hydrologyProject}
              value={props.vm.hydrologyForm.hydrologyProjectSlection}
              onChange={props.vm.handleHydrologyFormChange}
              onBlur={props.vm.validateInputField}
              options={props.vm.hydrologyProjectOptions}
              errorMsg=''
              initValue={props.vm.hydrologyForm.hydrologyProjectSlection}
              // className='wdt-hydrology-project-combobox'
              required={true}
              className={props.vm.hydrologyFormValidation.formErrors.hydrologyProject}
            /> : null}
          {/* </Col>
        <Col className='wdt-hydrology-project-button-col'> */}
          <button
            type="button"
            className="waterway-input-button usa-button"
            onClick={props.vm.onClickMetaDataToggle}
            disabled={!(props.vm.hydrologyForm.hydrologyProjectSlection && props.vm.hydrologyForm.hydrologyProjectSlection !== 'User Defined')}
          >
            View Metadata
          </button>
        </Col>
      </Row>
      <Row>
        <Col className='wdt-hydrology-frequency-combobox-col'>
          <ComboBox
            idAndName="hydrology_frequency"
            label="Frequency"
            aria-label="Frequency"
            valid={true}
            value={props.vm.hydrologyForm.hydrologyFrequencySelection}
            onChange={props.vm.handleHydrologyFormChange}
            onBlur={props.vm.validateInputField}
            options={props.vm.hydrologyFrequencyOptions}
            errorMsg=''
            initValue={"10 year"}
            NoInitialBlankOption={true}
          />
          {props.vm.hydrologyForm.hydrologyProjectSlection && props.vm.hydrologyForm.hydrologyProjectSlection !== 'User Defined' ?
            <button type="button" className="waterway-input-button usa-button" onClick={props.vm.handleLoadMetadata}>Load</button>
            : <button type="button" className="waterway-input-button usa-button" disabled >Load</button>
          }
        </Col>
      </Row>
      <div className='hydrology-parameters'>
        <div className='hydrology-parameter'>Drainage Area (ac)&emsp;&emsp;&emsp;<span>{props.vm.hydroProjectMetadata.drainageArea}</span></div>
        <div className='hydrology-parameter'>Weighted Curve Number&nbsp;&nbsp;<span>{props.vm.hydroProjectMetadata.weightedCurveNumber}</span></div>
        <div className='hydrology-parameter'>Watershed Length (ft)&emsp;&ensp; <span>{props.vm.hydroProjectMetadata.watershedLength}</span></div>
        <div className='hydrology-parameter'>Watershed Slope (%)&emsp;&ensp;&nbsp; <span>{props.vm.hydroProjectMetadata.watershedSlope}</span></div>
        <div className='hydrology-parameter'>Runoff (in)&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <span>{props.vm.hydroProjectMetadata.runOff}</span></div>
      </div>
      <div className="textfield-appearance">
        <Input
          idAndName='peak_flow'
          label='Peak Flow Q (cfs)'
          valid={!props.vm.hydrologyFormValidation.peak_flow}
          value={props.vm.hydroProjectMetadata.peakFlow !== undefined ? props.vm.hydroProjectMetadata.peakFlow : ""}
          type='number'
          onChange={props.vm.handleHydrologyFormChange}
          onBlur={props.vm.validateInputField}
          wrapperClassName='waterwayHorizontal'
          className={`${props.vm.hydrologyFormValidation.formErrors.peak_flow} no-spin-buttons`}
        />
      </div>
      <Input
        idAndName='initialQFraction'
        label='Initial Q Fraction (%)'
        valid={!props.vm.hydrologyFormValidation.initialQFraction}
        value={props.vm.hydrologyForm.initialQFraction}
        type='number'
        onBlur={props.vm.validateInputField}
        onChange={props.vm.handleHydrologyFormChange}
        step={"0.01"}
        wrapperClassName='waterwayHorizontal'
        className={props.vm.hydrologyFormValidation.formErrors.initialQFraction}
      />


    </div>
  )
})

const DesignControlForm = observer((props: ISubFormProps) => {
  return (
    <div className="wdt-design-control-container">
      <Row >
        <Col><div><strong>Fill Controls</strong></div></Col>
      </Row>
      <Row>
        <Col sm="5">
          <Input
            idAndName='sideFillSlope'
            label='Side Fill Slope (%)'
            valid={!props.vm.designControlFormValidation.sideFillSlope}
            value={props.vm.designControlForm.sideFillSlope}
            type='number'
            onBlur={props.vm.validateInputField}
            onChange={props.vm.handleDesignControlFormChange}
            step={"0.01"}
            wrapperClassName='waterwayHorizontal'
            className={props.vm.designControlFormValidation.formErrors.sideFillSlope}
          />
          <Input
            idAndName='sideWidthLimit'
            label='Side Width Limit (ft)'
            valid={!props.vm.designControlFormValidation.sideWidthLimit}
            value={props.vm.designControlForm.sideWidthLimit}
            type='number'
            onBlur={props.vm.validateInputField}
            onChange={props.vm.handleDesignControlFormChange}
            step={"0.01"}
            wrapperClassName='waterwayHorizontal'
            className={props.vm.designControlFormValidation.formErrors.sideWidthLimit}
          />
        </Col>
        <Col sm='6' className='wdt-designcontrol-berm-wrapper'>
          <Input
            idAndName='bermTopWidth'
            label='Berm Top Width (ft)'
            valid={!props.vm.designControlFormValidation.bermTopWidth}
            value={props.vm.designControlForm.bermTopWidth}
            type='number'
            onBlur={props.vm.validateInputField}
            onChange={props.vm.handleDesignControlFormChange}
            step={"0.01"}
            wrapperClassName='waterwayHorizontal'
            className={props.vm.designControlFormValidation.formErrors.bermTopWidth}
          />
          <Input
            idAndName='bermBackSlope'
            label='Berm Back Slope (ft/ft)'
            valid={!props.vm.designControlFormValidation.bermBackSlope}
            value={props.vm.designControlForm.bermBackSlope}
            type='number'
            onBlur={props.vm.validateInputField}
            onChange={props.vm.handleDesignControlFormChange}
            step={"0.01"}
            wrapperClassName='waterwayHorizontal'
            className={props.vm.designControlFormValidation.formErrors.bermBackSlope}
          />
        </Col>
      </Row>
      <Row >
        <Col><div><strong>Channel Ends</strong></div></Col>
      </Row>
      <div className='controls-radio-group channel-control-group'>
        <RadioGroup
          labelId="channel-end-controls"
          items={[
            {
              id: 'channel-end-length',
              name: 'channel_end_length',
              label: 'Channel End Length',
              className: 'control-radio-button usa-radio__input--tile',
              onChange: props.vm.selectChannelEndType,
              checked: props.vm.channelEndLengthControl,
            },
            {
              id: 'channel-end-slope',
              name: 'channel_end_slope',
              label: 'Channel End Slope',
              className: 'control-radio-button usa-radio__input--tile',
              onChange: props.vm.selectChannelEndType,
              checked: props.vm.channelEndSlopeControl,
            },
          ]}
        />
      </div>
      {props.vm.designControlForm.channelEndControl === 0 ?
        <Row>
          <Col sm='5'>
            <Input
              idAndName='startGradeLength'
              label='Start Length (ft)'
              valid={true}
              value={waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length === 0 ? props.vm.designControlForm.startGradeLength : waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].stationLength}
              type='number'
              onBlur={props.vm.validateInputField}
              onChange={props.vm.handleDesignControlFormChange}
              onFocus={props.vm.handleDesignControlFormFocus}
              step={"0.01"}
              wrapperClassName='waterwayHorizontal'
              className={props.vm.designControlFormValidation.formErrors.startGradeLength}
            />
          </Col>
          <Col sm='6' className='wdt-designcontrol-end-grade-length-wrapper'>
            <Input
              idAndName='endGradeLength'
              label='End Length (ft)'
              valid={true}
              value={waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length === 0 ? props.vm.designControlForm.endGradeLength : waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].stationLength}
              type='number'
              onBlur={props.vm.validateInputField}
              onChange={props.vm.handleDesignControlFormChange}
              onFocus={props.vm.handleDesignControlFormFocus}
              step={"0.01"}
              wrapperClassName='waterwayHorizontal'
              className={props.vm.designControlFormValidation.formErrors.endGradeLength}
            />
          </Col>
        </Row> : null}
      {props.vm.designControlForm.channelEndControl === 1 ?
        <Row>
          <Col sm='5'>
            <Input
              idAndName='startGradeSlope'
              label='Start Slope (%)'
              valid={!props.vm.designControlFormValidation.startGradeSlope}
              value={waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length === 0
                ? (waterwayDesignStore.startGradeNegative && String(props.vm.designControlForm.startGradeSlope) !== '' && !String(props.vm.designControlForm.startGradeSlope).startsWith('-') && String(props.vm.designControlForm.startGradeSlope) !== '0' ? `-${props.vm.designControlForm.startGradeSlope}` : props.vm.designControlForm.startGradeSlope)
                : (waterwayDesignStore.startGradeNegative && String(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade) !== '' && !String(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade).startsWith('-') && String(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade) !== '0' ? `-${waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade}` : waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].grade)
              }
              type='text'
              onBlur={props.vm.validateInputField}
              onChange={props.vm.handleDesignControlFormChange}
              step={"0.01"}
              wrapperClassName='waterwayHorizontal'
              className={props.vm.designControlFormValidation.formErrors.startGradeSlope}
            />
          </Col>
          <Col sm='6' className='wdt-designcontrol-end-grade-length-wrapper'>
            <Input
              idAndName='endGradeSlope'
              label='End Slope (%)'
              valid={!props.vm.designControlFormValidation.endGradeSlope}
              value={waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length === 0
                ? (waterwayDesignStore.endGradeNegative && String(props.vm.designControlForm.endGradeSlope) !== '' && !String(props.vm.designControlForm.endGradeSlope).startsWith('-') && String(props.vm.designControlForm.endGradeSlope) !== '0' ? `-${props.vm.designControlForm.endGradeSlope}` : props.vm.designControlForm.endGradeSlope)
                : (waterwayDesignStore.endGradeNegative && String(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade) !== '' && !String(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade).startsWith('-') && String(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade) !== '0' ? `-${waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade}` : waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade)
              }
              type='text'
              onBlur={props.vm.validateInputField}
              onChange={props.vm.handleDesignControlFormChange}
              step={"0.01"}
              wrapperClassName='waterwayHorizontal'
              className={props.vm.designControlFormValidation.formErrors.endGradeSlope}
            />

          </Col>
        </Row> : null}
      <Row >
        <Col><div><strong>Channel Type</strong></div></Col>
      </Row>
      <div className='control-channel-radio-group channel-control-group-wdt '>
        <RadioGroup
          labelId="channel-type-controls"
          items={[
            {
              id: 'trapezoid-wdt',
              name: 'trapezoid-wdt',
              label: 'Trapezoidal',
              className: 'control-radio-button usa-radio__input--tile ',
              onChange: props.vm.selectChannelType,
              checked: props.vm.trapezoidControlWDT,
              disabled: props.vm.disableChannelType && props.vm.parabolicControlWDT
            },
            {
              id: 'parabolic-wdt',
              name: 'parabolic-wdt',
              label: 'Parabolic',
              className: 'control-radio-button usa-radio__input--tile ',
              onChange: props.vm.selectChannelType,
              checked: props.vm.parabolicControlWDT,
              disabled: props.vm.disableChannelType && props.vm.trapezoidControlWDT
            },
          ]}
        />
      </div>
      <Row >
        <Col><div><strong>Other</strong></div>
        </Col>
      </Row>
      <Row>
        <Col sm='5'>
          <Input
            idAndName='freeBoard'
            label='Freeboard (ft)'
            valid={!props.vm.designControlFormValidation.freeBoard}
            value={props.vm.designControlForm.freeBoard}
            type='number'
            onBlur={props.vm.validateInputField}
            onChange={props.vm.handleDesignControlFormChange}
            step={"0.01"}
            wrapperClassName='waterwayHorizontal'
            className={props.vm.designControlFormValidation.formErrors.freeBoard}

          />

        </Col>
      </Row>

    </div>
  )
})

const WaterwayInputComponent = (props: WDTWInputProps) => {
  const vm = useRef(new WaterwayInputVM({ ...props })).current;
  // useEffect(() => {
  //   if(vm.isNotInitialRender){
  //     vm.validateReqInput();
  //   }
  // },[props.triggerReloadInputs])

  useEffect(() => {
    const getData = async () => {
      await props.getWDTContainerDataOnMount();
      await vm.getAlldataonMount();
      vm.isNotInitialRender = true;
      // vm.syncLiningMaterialWithStore();
    }
    getData();
    // Set up a reaction to watch for changes in the lining material
    // const disposer = reaction(
    //   () => waterwayDesignStore.selectedMaterial,
    //   (newMaterial) => {
    //     vm.syncLiningMaterialWithStore();
    //   }
    // );

    // return () => {
    //   disposer(); // Clean up the reaction when the component unmounts
    // };
  }, [])

  useEffect(() => {
    vm.updateStartEndLength();
  }, [waterwayDesignStore.updateStartEndLength])

  useEffect(() => {
    if (waterwayDesignStore.defaultLiningMaterialChanged[1] && (waterwayDesignStore.currentWaterwayDesignElementTypeId === 19 || waterwayDesignStore.waterwayType === 'Lined Waterway')) {
      vm.setupLiningMaterialInputs(waterwayDesignStore.defaultLiningMaterial);
      waterwayDesignStore.defaultLiningMaterialChanged[1] = false;
    }
  }, [waterwayDesignStore.defaultLiningMaterialChanged[1]])

  return (
    <div className="waterway-input-container">
      {/* informational button */}
      {vm.onClickInformation ? (
        <div>
          <Modal
            isOpen={vm.onClickInformation}
            toggle={vm.onClickInformationToggle}
            centered={true}
            className="eft-action-modal"
            aria-label={vm.headerTitle}
          >
            <ModalHeader toggle={vm.onClickInformationToggle} className='header-info-detail'>
              <div className="display-flex flex-align-center">
                <strong>{`Information Details on ${vm.headerTitle}`}</strong>
              </div>
              <a className="href-info-details105" href="/design/inputdetails" target="_blank">
                <strong>Open Information in a New Window</strong>
              </a>
            </ModalHeader>
            <ModalBody>
              <Container>
                <WaterWayInputDetails title={vm.headerTitle} />
              </Container>
            </ModalBody>
            <ModalFooter>
              <button className="usa-button usa-button--outline" onClick={vm.onClickInformationToggle}>
                Close
              </button>
            </ModalFooter>
          </Modal>
        </div>
      ) : null}
      {/* medataData button in Hydrology */}
      {vm.onClickMetaData ? (
        <div>
          <Modal
            isOpen={vm.onClickMetaData}
            toggle={vm.onClickMetaDataToggle}
            centered={true}
            className="eft-action-modal"
            aria-label={vm.headerTitle}
          >
            <ModalHeader toggle={vm.onClickMetaDataToggle} className="modal-bottom-margin">
              <div className="display-flex flex-align-center">
                <strong>{`Hydro Project ${vm.waterwayName}`}</strong>
                <a className="margin-left-105" target="_blank">
                  <Icon path={mdiOpenInNew} title="Open in new window" size={0.8} color="#005ea2" />
                </a>
              </div>
            </ModalHeader>
            <ModalBody>
              <Container>
                <div className={'wdt-storm-run-off-metadata-card'}>
                  <div className="">
                    <button className="banner-button " onClick={vm.toggleMetadataCardStorm}>
                      <h2 className="metadata-card-header">
                        Storm Run Off Metadata{' '}
                        <Icon
                          className="metadata-card-icon"
                          path={vm.metadataCardStormCollapse ? mdiMinusThick : mdiPlusThick}
                          title="Search"
                          size={1.3}
                          color="#205493"
                        />
                      </h2>
                    </button>
                  </div>

                  {vm.metadataCardStormCollapse ? (
                    <Row>
                      <Col className="col-headers">
                        <div>Drainage Area (ac)</div>
                        <div>Weighted Curve Number</div>
                        <div>Watershed Length (ft)</div>
                        <div>Watershed Slope (%)</div>
                        <div>Runoff (in)</div>
                        <div>Peak Flow Q (cfs)</div>
                      </Col>

                      <Col>
                        <div>{vm.hydroProjectMetadata.drainageArea}</div>
                        <div>{vm.hydroProjectMetadata.weightedCurveNumber}</div>
                        <div>{vm.hydroProjectMetadata.watershedLength}</div>
                        <div>{vm.hydroProjectMetadata.watershedSlope}</div>
                        <div>{vm.hydroProjectMetadata.runOff}</div>
                        <div>{vm.hydroProjectMetadata.peakFlow}</div>
                      </Col>
                    </Row>
                  ) : null}
                </div>
                <div className={'wdt-storm-run-off-metadata-card'}>
                  <div className="">
                    <button className="banner-button" onClick={vm.toggleMetadataCardProject}>
                      <h2 className="metadata-card-header">
                        Project Details{' '}
                        <Icon
                          className="metadata-card-icon"
                          path={vm.metadataCardProjectCollapse ? mdiMinusThick : mdiPlusThick}
                          title="Search"
                          size={1.3}
                          color="#205493"
                        />
                      </h2>
                    </button>
                  </div>
                  {vm.metadataCardProjectCollapse ? (
                    <Row>
                      <Col className="col-headers">
                        <div>Status</div>
                        <div>State</div>
                        <div>County</div>
                        <div>Watershed Centroid</div>
                        <div>Owner</div>
                        <div>Last Change By</div>
                        <div>Last Change Date</div>
                      </Col>

                      <Col>
                        <div>{vm.hydroProjectMetadata.projectStatus}</div>
                        <div>{vm.hydroProjectMetadata.state}</div>
                        <div>{vm.hydroProjectMetadata.county}</div>
                        <div>{vm.hydroProjectMetadata.watershedCentroid}</div>
                        <div>{vm.hydroProjectMetadata.projectOwner}</div>
                        <div>{vm.hydroProjectMetadata.lastChangedBy}</div>
                        <div>{vm.hydroProjectMetadata.lastChangedDate}</div>
                      </Col>
                    </Row>
                  ) : null}
                </div>
              </Container>
            </ModalBody>
            <ModalFooter>
              <button className="usa-button usa-button--outline" onClick={vm.onClickMetaDataToggle}>
                Close
              </button>
            </ModalFooter>
          </Modal>
        </div>
      ) : null}
      <Row>
        <Col xs="6">
          <Accordion
            className={'wdt-info accordion-wrapper'}
            headers={['Info']}
            onClickInformationToggle={vm.onClickInformationToggle}
            waterwayWizardStatus={vm.waterWayWizardStatus}
            light={true}
            iconPathQ={true}
          >
            <InfoForm vm={vm} />
          </Accordion>
        </Col>
        <Col xs="6">
          <Accordion
            className={'wdt-hydrology accordion-wrapper'}
            headers={['Hydrology']}
            onClickInformationToggle={vm.onClickInformationToggle}
            waterwayWizardStatus={vm.waterWayWizardStatus}
            light={true}
            iconPathQ={true}
            actionButton={
              <button
                className="actions-button usa-button usa-button--unstyled text-no-underline"
                id={'actions-button'}
                onClick={vm.resetHydrology}
              >
                <Icon path={mdiRestore} title="Reset" size={1.05} />
                &nbsp;Reset
              </button>
            }
          >
            <div className="wdt-hydrology-sub-container">
              <HydrologyForm vm={vm} />
              <Accordion
                className={'accordion-wrapper'}
                headers={['Alignment']}
                onClickInformationToggle={vm.onClickInformationToggle}
                waterwayWizardStatus={vm.waterWayWizardStatus}
                light={true}
                iconPathQ={true}
              >
                <AlignmentForm vm={vm} />
              </Accordion>
            </div>
          </Accordion>
        </Col>
      </Row>

      <Row>
        <Col xs="12">
          <Accordion
            className={'wdt-design-control accordion-wrapper'}
            headers={['Design Controls']}
            onClickInformationToggle={vm.onClickInformationToggle}
            waterwayWizardStatus={vm.waterWayWizardStatus}
            light={true}
            iconPathQ={true}
          >
            <DesignControlForm vm={vm} />
          </Accordion>
        </Col>
      </Row>
      <Row>
        <Col sm="12">
          <WaterwayCommentsComp vm={vm} />
        </Col>
      </Row>
      <Row className='sticky-button-row'>
        <hr />
        <Col>
          <button
            type="button"
            className="waterway-input-save-button usa-button"
            onClick={() => vm.handleSave('save_and_proceed')}
            disabled={designStore.disableSaveProceedButtonInputPage || !designStore.hasProject() || !designStore.hasSurfaceTest() || waterwayDesignStore.isLoading}
          >
            Save & Proceed
          </button>

          <button
            type="button"
            className="waterway-input-save-button usa-button"
            onClick={vm.handleSave}
            disabled={designStore.disableSaveButtonInputPage || !designStore.hasSurfaceTest() || waterwayDesignStore.isLoading}
          >
            Save
          </button>
          <button
            className="waterway-input-save-button usa-button usa-button--outline"
            onClick={vm.handleCancelEdits}
          >
            Close
          </button>
        </Col>
      </Row>


      {waterwayDesignStore.waterwayInputsPageInputsChange && (
        <UserLeavingWarning
          when={waterwayDesignStore.waterwayInputsPageInputsChange}
          section="Waterway Inputs"
          onOK={() => { return false }}
          okText="Return"
          text={waterwayDesignStore.notifications.unsavedEdits}
        />
      )}
      {vm.showLiningMaterialConfirmation[0] && (
        <Popup
          trigger={vm.showLiningMaterialConfirmation[0] as boolean}
          setTrigger={vm.cancelLiningMaterialChangeAction}
          title="Update Lining Material"
          handleCancel={vm.cancelLiningMaterialChangeAction}
          cancelText="Close"
          handleOK={vm.confirmLiningMaterialChangeAction}
          okText="Yes"
        >
          <p>Changing the default lining material will update the lining material for all reaches on the design page. Do you want to proceed?</p>
        </Popup>
      )}
    </div>
  );
}

export const WaterwayInput = observer(WaterwayInputComponent);
